import {
  SectionElement,
  defineElement,
  onClick,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/common-description/common-description.ts
var CommonDescription = class extends SectionElement {
  handleOpenButtonClick(elm) {
    const index = parseInt(elm.dataset.title);
    this.texts.forEach((text) => {
      text.dataset.text === index.toString() ? text.classList.remove("hidden") : text.classList.add("hidden");
    });
    this.titles.forEach((title) => {
      title.dataset.title === index.toString() ? title.classList.add("!bg-white") : title.classList.remove("!bg-white");
    });
    this.titles.forEach(
      (title) => {
        title.dataset.title === index.toString() ? title.lastElementChild.classList.add("!text-primary") : title.lastElementChild.classList.remove("!text-primary");
      }
    );
  }
  handleAccordionClick(elm) {
    const index = parseInt(elm.dataset.openButton);
    if (this.accordions[index].isOpen) {
      this.close(index);
    } else {
      this.closeAll();
      this.open(index);
    }
  }
  open(index) {
    this.accordions[index].open();
    this.chevrons[index].classList.add("rotate-180");
  }
  close(index) {
    this.accordions[index].close();
    this.chevrons[index].classList.remove("rotate-180");
  }
  closeAll() {
    this.accordions.forEach((accordion, index) => {
      this.close(index);
    });
  }
  handleDetailsButtonClick(elm) {
    const index = parseInt(elm.dataset.detailsButton);
    this.changeDesktopContent(index);
    this.changeMobileContent(index);
  }
  handleDetailsButtonClickMobile(elm) {
    const index = parseInt(elm.dataset.detailsButtonMobile);
    this.changeMobileContent(index);
    this.changeDesktopContent(index);
  }
  changeMobileContent(index) {
    this.detailsContentsMobile.forEach((content) => {
      if (content.dataset.detailsContentMobile === index.toString()) {
        content.classList.remove("hidden");
        if (content.getBoundingClientRect().top < 112 && window.screen.width < 768) {
          window.scrollTo({ top: content.getBoundingClientRect().top + window.pageYOffset - 112, behavior: "instant" });
        }
      } else {
        content.classList.add("hidden");
      }
    });
    this.detailsButtonsMobile.forEach((button) => {
      button.dataset.detailsButtonMobile === index.toString() ? button.dataset.active = "true" : button.dataset.active = "false";
    });
  }
  changeDesktopContent(index) {
    this.detailsContents.forEach((content) => {
      if (content.dataset.detailsContent === index.toString()) {
        content.classList.remove("hidden");
      } else {
        content.classList.add("hidden");
      }
    });
    this.detailsButtons.forEach((button) => {
      button.dataset.detailsButton === index.toString() ? button.dataset.active = "true" : button.dataset.active = "false";
    });
  }
};
__decorateClass([
  queryAll("[data-text]")
], CommonDescription.prototype, "texts", 2);
__decorateClass([
  queryAll("[data-title]")
], CommonDescription.prototype, "titles", 2);
__decorateClass([
  queryAll("[data-details-content]")
], CommonDescription.prototype, "detailsContents", 2);
__decorateClass([
  queryAll("[data-details-button]")
], CommonDescription.prototype, "detailsButtons", 2);
__decorateClass([
  queryAll("[data-details-content-mobile]")
], CommonDescription.prototype, "detailsContentsMobile", 2);
__decorateClass([
  queryAll("[data-details-button-mobile]")
], CommonDescription.prototype, "detailsButtonsMobile", 2);
__decorateClass([
  onClick("[data-title]")
], CommonDescription.prototype, "handleOpenButtonClick", 1);
__decorateClass([
  queryAll("[data-accordion]")
], CommonDescription.prototype, "accordions", 2);
__decorateClass([
  queryAll("[data-chevron]")
], CommonDescription.prototype, "chevrons", 2);
__decorateClass([
  onClick("[data-open-button]")
], CommonDescription.prototype, "handleAccordionClick", 1);
__decorateClass([
  onClick("[data-details-button]")
], CommonDescription.prototype, "handleDetailsButtonClick", 1);
__decorateClass([
  onClick("[data-details-button-mobile]")
], CommonDescription.prototype, "handleDetailsButtonClickMobile", 1);
CommonDescription = __decorateClass([
  defineElement("common-description")
], CommonDescription);
export {
  CommonDescription
};
